import { API, authClient } from "../index";

// Get all plans
export const getSubPlans = () => {
    return authClient().get(`${API}/subPlan/?getDisabled=true`);
};

// Get all active plans
export const getAllActiveSubPlans = () => {
    return authClient().get(`${API}/subPlan/`);
};

// Get subPlan by id
export const getSubPlanById = (id) => {
    return authClient().get(`${API}/subPlan/${id}`);
};

// Delete subPlan
export const deleteSubPlan = (id) => {
    return authClient().delete(`${API}/subPlan/${id}`);
};

// Create subPlan
export const postSubPlan = async (subPlan) => {
    return authClient().post(`${API}/subPlan`, subPlan);
};

// Update subPlan
export const updateSubPlan = async (id, subPlan) => {
    return authClient().put(`${API}/subPlan/${id}`, subPlan);
};

// Change status subPlan
export const changeStatusSubPlan = async (id, active) => {
    return authClient().put(`${API}/subPlan/change-status/${id}`, { active });
};
